// @flow
import * as React from 'react';
import styled from 'styled-components';
import TextField from 'material-ui/TextField';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

type Props = {
  onBlur: (numeric: number) => void;
  value?: number;
  defaultValue?: number;
  style?: Object;
  className?: string;
  suffix?: any;
  prefix?: any;
  min?: number;
  max?: number;
  errorText?: string;
};

type State = {
  value: string;
};

class NumericTextField extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const value = props.value || props.defaultValue || 0;

    this.state = {
      value: value.toString(),
    };
  }

  componentWillReceiveProps(nextProps: Props): void {
    if (nextProps.value !== this.props.value) {
      const value = nextProps.value || nextProps.defaultValue || 0;
      this.setState({ value: value.toString() });
    }
  }

  onChange = (event: Object, value: string): void => {
    const number = Number.parseFloat(value);

    if (!Number.isNaN(number)) {
      this.setState({ value: number.toString() });
    }

    if (!value) {
      this.setState({ value });
    }
  }

  onBlur = (event: Object): void => {
    const value = event.target.value;

    if (window.isFinite(value)) {
      const numericValue = window.parseInt(value);
      this.props.onBlur(numericValue);
    }
  }

  render() {
    return (
      <Wrapper style={this.props.style} className={this.props.className}>
        {this.props.prefix && this.props.prefix}
        <TextField
          id="numeric-field"
          type="number"
          min={this.props.min}
          max={this.props.max}
          value={this.state.value}
          onBlur={this.onBlur}
          onChange={this.onChange}
          fullWidth
          errorText={this.props.errorText}
        />
        {this.props.suffix && this.props.suffix}
      </Wrapper>
    );
  }
}

export default NumericTextField;



// WEBPACK FOOTER //
// ./src/statsradio/components/NumericTextField.js